import React from 'react';
import { Show, TabbedShowLayout, Tab, useRecordContext } from 'react-admin';
import { Box, Skeleton } from '@mui/material';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import CampaignHeader from './components/CampaignHeader';
import ResultTab from './components/ResultTab';
import LevelsTimelineTab from './components/LevelsTimelineTab';
import CustomersTab from './components/CustomersTab';
import AuditTab from './components/AuditTab';

// ─── Main Show ────────────────────────────────────────────────
// Contrato: docs/superpowers/plans/2026-09-29-recuperacao-clientes-campanha.md
// (seção "Contratos da API" — GET /customer-recovery-rules/{id} → CampaignDetail).
// Cabeçalho com ações (avançar/encerrar) fora das abas, igual à spec §8.3.

const CampaignShowContent: React.FC = () => {
  const record = useRecordContext();
  if (!record) return <Skeleton variant="rectangular" height={400} sx={{ m: 2 }} />;

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <CampaignHeader campaign={record} />
      <TabbedShowLayout>
        <Tab label="Resultado">
          <ResultTab />
        </Tab>
        <Tab label="Níveis">
          <LevelsTimelineTab />
        </Tab>
        <Tab label="Clientes">
          <CustomersTab campaign={record} />
        </Tab>
        <Tab label="Auditoria">
          <AuditTab campaign={record} />
        </Tab>
      </TabbedShowLayout>
    </Box>
  );
};

const CustomerRecoveryRuleShow: React.FC<any> = (props) => (
  <Permission permission={PERMISSIONS.CUSTOMER_RECOVERY_RULES}>
    <Show title="Campanha de Recuperação" {...props}>
      <CampaignShowContent />
    </Show>
  </Permission>
);

export default CustomerRecoveryRuleShow;
